import Table from 'react-bootstrap/Table';
import React from 'react';

type TableHeader = string | { label: string; filter?: React.ReactNode };

interface DataTableProps<T> {
  headers: TableHeader[];
  data: T[];
  renderRow: (row: T, index: number) => React.ReactNode;
  emptyMessage?: string;
}

const TableHeaderCell = ({ header }: { header: TableHeader }) => {
  if (typeof header === 'string') {
    return <th>{header}</th>;
  }

  return (
    <th>
      <div className="d-flex align-items-center justify-content-center gap-1">
        <div>{header.label}</div>
        {header.filter && <div>{header.filter}</div>}
      </div>
    </th>
  );
};

export function DataTable<T>({
  headers,
  data,
  renderRow,
  emptyMessage = 'No hay datos disponibles.',
}: DataTableProps<T>) {
  return (
    <Table bordered hover>
      <thead>
        <tr className="text-center headers">
          {headers.map(header => (
            <TableHeaderCell
              key={typeof header === 'string' ? header : header.label}
              header={header}
            />
          ))}
        </tr>
      </thead>
      <tbody className="align-middle text-center rows">
        {data.length > 0 ? (
          data.map((row, index) => renderRow(row, index))
        ) : (
          <tr>
            <td
              colSpan={headers.length}
              className="text-center text-muted py-4"
            >
              {emptyMessage}
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
}
